import AuthService from "./AuthService";
import AuthApi from "./AuthApi";
import enviromment from '../../environment';
import Alert from '../../components/Alert'

export default class AuthServiceWA extends AuthService {

    static async login() {
        return AuthApi.get(`/v1/authenticate/wa/${enviromment.sistema}`).then(
            res => {
                let authorization = res.data.data;
                if (authorization && authorization.token)
                    this._saveCredentials(authorization);
            });
    }

    static async refreshCredentials() {
        try {
            this.logout();
            await this.login();
        } catch (error) {
            Alert.show('Falha ao Atualizar', error.message);
            console.log('permission rejected');
        }
    }

}
